<template>
  <div class="about-page">
    <trsShopBreadcrumb
      class="about-page__breadcrumb"
      :breadcrumbList="breadcrumbList"
      :skip="true"
    />
    <div class="about-content">
      <section class="about-section">
        <h3 class="about-section__heading">COMPANY PROFILE</h3>
        <p class="about-section__text">
          With more than 17 years sales and purchase experience in motorbike business, and More than 17 years experience in motorcycle parts production. Our sales team can work with fast reply and give a professional detail information introduction on products, we guarantee that all parts warranted if a problem is due to the quality issue of the product itself.
        </p>
        <p class="about-section__text">
          2008 Tarazon was founded by in Jiangsu, China as a cnc parts supplier for major European motorcycle and ATV makers, Tarazon services North and South America, Australia and the Far East. And all of our products are produced by our own factories. we have professional sales, management and design teams.
        </p>
        <p class="about-section__text">
          At present，We have established long-term relationships with many world-renowned brands and have more than 300 cooperative customers.
        </p>
        <p class="about-section__text">
          If you would like to produced a special product,or you may want to make a slight change to the product Appearance, design, colors or fitments, please do not hesitate to contact us,We will provide you the best custom service.
        </p>
      </section>

      <hr class="about-divider">

      <section class="about-section">
        <h3 class="about-section__heading">QUALITY CONTROL</h3>
        <p class="about-section__text">Quality is our top priority.</p>
        <p class="about-section__text">
          Every product passes through multiple manufacturing processes and rigorous quality inspections before shipment. Our quality control team conducts comprehensive inspections throughout the entire production cycle, including dimensional verification, appearance inspection, and functional testing.
        </p>
        <p class="about-section__text">
          We perform 100% final inspection before delivery to ensure every product meets customer expectations.
        </p>
      </section>

      <hr class="about-divider">

      <section class="about-section">
        <h3 class="about-section__heading">GLOBAL MARKET</h3>
        <p class="about-section__text">
          TARAZON has established long-term partnerships with customers around the world and has earned a strong reputation for product quality, competitive pricing, and reliable service.
        </p>
        <p class="about-section__text">
          Our major markets include Europe, North America, South America, Australia, and Asia.
        </p>
      </section>

      <hr class="about-divider">

      <section class="about-section">
        <h3 class="about-section__heading">OEM &amp; CUSTOMIZATION</h3>
        <p class="about-section__text">
          In addition to our standard product range, TARAZON provides OEM and customized manufacturing services for motorcycle brands, distributors, wholesalers, and professional racing teams.
        </p>
        <p class="about-section__text">
          We support product development from concept to mass production, helping customers bring high-quality motorcycle parts to market efficiently.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trsShopBreadcrumb from '@/components/layout/shopping/breadcrumb.vue';

export default {
  name: 'trsAboutTalison',
  mixins: [Mixin],
  components: {
    trsShopBreadcrumb
  },
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
          path: '/index'
        },
        {
          name: 'ABOUT TARAZON',
          path: '/trsAboutTalison'
        }
      ],
    };
  },
};
</script>

<style scoped lang="less">
.about-page {
  width: 1200px;
  margin: 0 auto;
}

.about-page__breadcrumb {
  margin: 0 auto;
  width: 1200px;
}

.about-content {
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: 32px 40px 40px;
  color: #333;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
  line-height: 1.8;
}

.about-section {
  margin-bottom: 8px;
}

.about-section__heading {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  line-height: 1.5;
}

.about-section__text {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.about-divider {
  margin: 24px 0;
  border: none;
  border-top: 1px solid #e8e8e8;
}
</style>
